<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="brand">ДРУЖБА МЕБЕЛЬ</div>
      <h1>{{ isLoginMode ? 'Вход' : 'Регистрация' }}</h1>
      <p class="subtitle">
        {{ isLoginMode ? 'Войдите в аккаунт' : 'Создайте аккаунт, чтобы оформить заказ' }}
      </p>

      <div class="switcher">
        <button
          type="button"
          :class="['switch-btn', { active: isLoginMode }]"
          @click="setMode(true)"
        >
          Вход
        </button>

        <button
          type="button"
          :class="['switch-btn', { active: !isLoginMode }]"
          @click="setMode(false)"
        >
          Регистрация
        </button>
      </div>

      <form class="form" @submit.prevent="submitForm">
        <div v-if="!isLoginMode" class="field">
          <label for="fio">ФИО</label>
          <input
            id="fio"
            v-model.trim="form.FIO"
            type="text"
            placeholder="Введите ФИО"
          />
        </div>

        <div class="field">
          <label for="email">Email</label>
          <input
            id="email"
            v-model.trim="form.email"
            type="email"
            placeholder="Введите email"
            required
          />
        </div>

        <div class="field">
          <label for="password">Пароль</label>
          <input
            id="password"
            v-model.trim="form.password"
            type="password"
            placeholder="Введите пароль"
            required
          />
        </div>

        <div v-if="!isLoginMode" class="field">
          <label for="phone">Телефон</label>
          <input
            id="phone"
            v-model.trim="form.phone"
            type="text"
            placeholder="+7 (...)"
          />
        </div>

        <div v-if="!isLoginMode" class="field-row">
				  <div class="field">
				    <label for="vk">
				      VK <span class="optional-label">(необязательно)</span>
				    </label>
				    <input
				      id="vk"
				      v-model.trim="form.vk"
				      type="text"
				      placeholder="Ссылка или ник"
				    />
				  </div>

				  <div class="field">
				    <label for="tg">
				      Telegram <span class="optional-label">(необязательно)</span>
				    </label>
				    <input
				      id="tg"
				      v-model.trim="form.tg"
				      type="text"
				      placeholder="@username"
				    />
				  </div>
				</div>

        <p v-if="errorMessage" class="message error">{{ errorMessage }}</p>
        <p v-if="successMessage" class="message success">{{ successMessage }}</p>

        <button class="submit-btn" type="submit" :disabled="loading">
          {{ loading ? 'Подождите...' : isLoginMode ? 'Войти' : 'Зарегистрироваться' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      isLoginMode: true,
      successMessage: '',
      form: {
        FIO: '',
        email: '',
        password: '',
        phone: '',
        vk: '',
        tg: ''
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters['auth/loading']
    },
    errorMessage() {
      return this.$store.getters['auth/error']
    }
  },
  methods: {
    setMode(isLogin) {
      this.isLoginMode = isLogin
      this.successMessage = ''
      this.$store.dispatch('auth/clearError')
    },

    async submitForm() {
		  this.successMessage = ''
		  await this.$store.dispatch('auth/clearError')

		  let result = null

		  if (this.isLoginMode) {
		    result = await this.$store.dispatch('auth/login', {
		      email: this.form.email,
		      password: this.form.password
		    })

		    if (result && result.ok) {
		      this.$router.push('/')
		    }

		    return
		  }

		  result = await this.$store.dispatch('auth/register', {
		    FIO: this.form.FIO,
		    email: this.form.email,
		    password: this.form.password,
		    phone: this.form.phone,
		    vk: this.form.vk,
		    tg: this.form.tg
		  })

		  if (result && result.ok) {
		    this.successMessage = result.message || 'Регистрация прошла успешно'
		    this.isLoginMode = true
		  }
		}
  }
}
</script>


<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e8eefc 100%);
}

.auth-card {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.12);
}

.brand {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #2563eb;
  margin-bottom: 12px;
}

h1 {
  margin: 0;
  font-size: 32px;
}

.subtitle {
  margin: 12px 0 24px;
  color: #6b7280;
  line-height: 1.5;
}

.switcher {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 24px;
}

.switch-btn {
  border: 1px solid #dbe3f0;
  background: #f8fafc;
  color: #334155;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
}

.switch-btn.active {
  background: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field,
.field-row {
  width: 100%;
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
}

input {
  width: 100%;
  border: 1px solid #dbe3f0;
  border-radius: 12px;
  padding: 14px 16px;
  outline: none;
  background: #ffffff;
}

input:focus {
  border-color: #2563eb;
}

.message {
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 14px;
}

.message.error {
  background: #fee2e2;
  color: #b91c1c;
}

.message.success {
  background: #dcfce7;
  color: #166534;
}

.submit-btn {
  border: none;
  background: #111827;
  color: #ffffff;
  border-radius: 12px;
  padding: 15px;
  cursor: pointer;
  font-weight: 700;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .auth-card {
    padding: 24px;
  }

  h1 {
    font-size: 26px;
  }

  .field-row {
    grid-template-columns: 1fr;
  }
}
</style>